<template>
    <div class="sample-selector" @click="expand = !expand">
        <div class="arrow-down" :class="[{ active: expand }]">
            <span class="select-item">{{ selectItem }}</span>
            <icon class="icon" name="arrow-down"></icon>
        </div>
        <div class="type-down">
            <ul :class="{ ulShow: expand }">
                <li v-for="item in menusList" :key="item" @click.stop="clickItem(item)">
                    {{ item }}
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    name: 'SampleSelector',
    components: {},
    props: {
        menusList: {
            type: Array,
            default: () => []
        },
        selectItem: {
            type: String,
            default: '0'
        }
    },
    data() {
        return {
            expand: false
        }
    },
    methods: {
        clickItem(item) {
            this.expand = false
            this.$emit('changeItem', item)
        }
    }
}
</script>

<style lang="scss" scoped>
.sample-selector {
    padding: 0 40px;
    position: relative;
    background: #ffffff;
    .arrow-down {
        width: 100%;
        border: 1px solid #999999;
        border-radius: 10px;
        height: 80px;
        padding: 18px 20px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .select-item {
            color: #000000;
            font-weight: 600;
            font-size: 28px;
        }
        .icon {
            width: 20px;
        }
        &.active {
            border-bottom-left-radius: 0;
            border-bottom-right-radius: 0;
            .icon {
                transform: rotate(180deg);
            }
        }
    }
    .type-down {
        width: 100%;
        position: absolute;
        top: 100%;
        left: 0;
        padding: 0 40px;
        z-index: 1;
        background: #fff;
        ul {
            width: 100%;
            border: 1px solid #999;
            border-top: none;
            display: none;
            border-radius: 5px;
            padding-bottom: 18px;
            li {
                line-height: 40px;
                font-size: 28px;
                padding: 18px 20px;
                padding-bottom: 0;
                color: #303030;
                &:nth-last-of-type(1) {
                    border-bottom: none;
                }
            }
            &.ulShow {
                display: block;
                max-height: 400px;
                overflow: auto;
                border-bottom-left-radius: 10px;
                border-bottom-right-radius: 10px;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/investor/components/sample-selector.vue